<template>
	<div>
		<div v-for="(value,key) in original" :key="key">
			<div v-if="isKeyUsed(value)" class="mb-2 mt-2">
				<div v-if="value.value === 'Parking'" style="height: 35px;"></div>
			</div>
			<p v-if="isKeyUsed(value)" class="mb-2 mt-2 amenities-header">
				{{ value.value }}
			</p>
			<div class="ml-3">
				<div v-for="obj in getValuesUsed(value)" class="mb-3" :key="obj.value">
					<div style="display: inline-block; vertical-align: middle; width: 35px; height: 16px;" class="amenities-value text-xs-center">
						<v-icon small left v-if="getIcon(obj.icon).type=='fa'">{{ getIcon(obj.icon).value }}</v-icon>
						<img v-else :src="getIcon(obj.icon).value" height="18" style="opacity: 0.6;" alt="">
					</div>
					<p style="display: inline-block; vertical-align: middle; line-height: 16px; vertical-align: middle" class="ma-0 amenities-name">
						{{obj.value}}
					</p>
				</div>
			</div>
			<div class="ml-3">
				<div v-for="obj in getInputsUsed(value)" class="mt-3" :key="obj.value">
					<div style="display: inline-block; width: 35px; opacity: 0.8;" class="amenities-value text-xs-center">
						<v-icon small left v-if="getIcon(obj.icon).type=='fa'">{{ getIcon(obj.icon).value }}</v-icon>
						<img v-else :src="getIcon(obj.icon).value" height="16" alt="">
					</div>
					<p style="display: inline-block; line-height: 16px; vertical-align: middle" class="ma-0 amenities-name">
						{{obj.input}} : <span class="amenities-value">{{obj.value}}</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['original', 'fields', 'inputs'],
	methods: {
		getIcon(icon) {
			if (icon.indexOf('fa') > -1) {
				return {
					type: 'fa',
					value: icon
				}
			} else {
				return {
					type: 'svg',
					value: '/static/images/icon/amenities/' + icon
				}
			}
		},
		isKeyUsed(contents) {
			let isUsed = false
			if (typeof contents === 'object' && contents !== null) {
				for (var prop in contents) {
					if (Object.prototype.hasOwnProperty.call(contents, prop)) {
						for (var key in this.fields) {
							if (Object.prototype.hasOwnProperty.call(this.fields, key)) {
								if (this.fields[key] === prop) {
									return true
								}
							}
						}
						for (key in this.inputs) {
							if (Object.prototype.hasOwnProperty.call(this.inputs, key)) {
								if (key === prop) {
									return true
								}
							}
						}
						if (this.isKeyUsed(contents[prop]) === true) {
							isUsed = true
						}
					}
				}
			} else {
				return false
			}
			return isUsed
		},
		getValuesUsed(contents) {
			let vals = []
			if (typeof contents === 'object' && contents !== null) {
				for (var prop in contents) {
					if (Object.prototype.hasOwnProperty.call(contents, prop)) {
						for (var key in this.fields) {
							if (Object.prototype.hasOwnProperty.call(this.fields, key)) {
								if (this.fields[key] === prop) {
									// let dontPush = false
									// for (var prop2 in contents[prop]) {
									// 	if (Object.prototype.hasOwnProperty.call(contents, prop)) {
									// 		if (prop2.includes(prop)) {
									// 			dontPush = true
									// 		}
									// 	}
									// }
									// if (dontPush === false) {
									// 	if ()
									if (contents[prop].icon) {
										vals.push({
											value: contents[prop].value,
											icon: contents[prop].icon
										})
									}
									// }
								}
							}
						}
						let temp = this.getValuesUsed(contents[prop])
						if (temp !== null) {
							vals.push(temp)
						}
					}
				}
			} else {
				return null
			}

			return [].concat.apply([], vals)
		},
		getInputsUsed(contents) {
			let vals = []
			if (typeof contents === 'object' && contents !== null) {
				for (var prop in contents) {
					if (Object.prototype.hasOwnProperty.call(contents, prop)) {
						for (var key in this.inputs) {
							if (Object.prototype.hasOwnProperty.call(this.inputs, key)) {
								if (key === prop) {
									if (contents[prop].icon) {
										vals.push({
											input: contents[prop].value,
											value: this.inputs[key],
											icon: contents[prop].icon
										})
									}
								}
							}
						}
						let temp = this.getInputsUsed(contents[prop])
						if (temp !== null) {
							vals.push(temp)
						}
					}
				}
			} else {
				return null
			}
			return [].concat.apply([], vals)
		}
	}
}
</script>

<style>
.amenities-header {
	font-size: 1em;
	color: #666;
	font-weight: bold;
}

.amenities-name {
	font-size: 0.9em;
	color: #aaa;
}

.amenities-value {
	font-size: 0.9em;
	color: #888;
	font-weight: bold;
}
</style>
